import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const selectTypeProps = {
	
	options: [{label:"All Records",description:0}, {label:"Specific Record",description:1}, ],
	// getOptionLabel: (option) => option.description + ' - ' + option.branchidno
	getOptionLabel:  (option) => option.label
};


const VoidReport = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));// jc_user_id_no - branchidno
	const [filterType, setFilterType] = useState(0);//filter type dropdown, 0 - all records, 1 - specific record
	const [fType, setfType] = useState('');//ftype, eg. SO
	const [refNum, setrefNum] = useState('');//ref num

	// Data Fetching
	useEffect(() => {
		data();
	}, []);
	const x = 0;

	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	
	const types = [
		{label:"CASH VOUCHER",description:"CASH VOUCHER"},
		{label:"CHECK",description:"CHECK"},
		{label:"COLLECTION",description:"COLLECTION"},
		{label:"GL TRANSACTION",description:"GL"},
		{label:"INVENTORY ADJUSTMENT",description:"INVENTORY ADJUSTMENT"},
		// {label:"PACKAGE PURCHASE",description:"PACKPURCHASE"},
		{label:"PACKAGE SALES",description:"PACKSALES"},
		{label:"PURCHASE ORDER RETURN",description:"PO RETURN"},
		{label:"PURCHASE ORDER",description:"PO"},
		{label:"SALES ORDER",description:"SO"},
		{label:"SALES ORDER RETURN",description:"SALES RETURN"},
	]

	const selectTranTypeProps = {
		options: types,
		getOptionLabel: (option) => option.label,
	};

	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        const result = await axios.get(
			process.env.REACT_APP_API_URL+'get_void_report', {
            params:{
                date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
				jc_user_id_no: useridNo,  
				filter_type: filterType,
				ftype : fType,
				ref_no : refNum,
            }
        })
		setPosts(result.data.data);
		setDataLoaded(true);
    }

	const data = async () => {
		// const res = await axios.get(
		// process.env.REACT_APP_API_URL+'get_void_report',  {
        //     params:{
        //         date_from: '2015/01/01/', 
        //         date_to: '2016/12/01/',   
		// 		jc_user_id_no: '00593494', 
		// 		filter_type: 0,
		// 		ftype : 'SO',
		// 		ref_no : 12, 
        //     }
        // })		
		// console.log(res.data);
		// console.log(res.data.data);
	    // setPosts(res.data.data);

		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "id",
			label: "ID",
		},
		{
			name: "trandate",
			label: "Transaction Date",
		},
		{
			name: "typemask",
			label: "Type",
		},
		{
			name: "refid",
			label: "Reference ID"
		},
		{
			name: "username",
			label: "Username"
		},
		{
			name: "branchidno",
			label: "Branch ID No"
		},
		{
			name: "reason",
			label: "Reason"

		},
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: true,  //add this
		print: true,
		viewColumns:false, //add this
		pagination: true,
		downloadOptions: {
			filename : 'VoidReport.csv' //change filename of csv
		}
		
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/reports">
						<h2 className="header-title">Reports</h2>
					</NavLink>
					<Typography color="textPrimary">Void Report</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
					<Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>

						<Grid item xs={12} sm={5} lg={5} xl={3}>
							 {/* <NativeSelect
								value={filterType}
								onChange={e => setfilterType(e.target.value)}
								inputProps={{
									name: 'Filter Type',
								}}>
								<option value=''>Choose Type</option>
								<option value='0'>All Records</option> 
								<option value='1'>Specific Records</option> 	  
							</NativeSelect>
							<FormHelperText>Select Type</FormHelperText>  */}
							<Autocomplete
									    style={{marginTop:  "-15px"}}
                                        {...selectTypeProps}
                                        autoComplete
                                        includeInputInList
										className={classes.autoComplete}
                                        renderInput={(params) => (
                                            <TextField
												{...params}
                                                margin="normal"
                                                label="Select Type"
												variant="outlined"
												required="true"
                                            />
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												if(newValue.label == 'All Records')
													setFilterType(0);
												else if(newValue.label == 'Specific Record'){
													setFilterType(1);
												}
											}
										}}
                            />
						</Grid>

						{/* <Grid item xs={2}>
							<Input style={{marginTop:  "21px"}} placeholder="Branch ID No" inputProps={{ 'aria-label': 'branch id no' }} onChange={e => setuseridNo(e.target.value)}/>
						</Grid> */}

						<Grid item xs={12} sm={4} lg={4} xl={2}> 
							<Input style={{marginTop:  "21px"}} fullWidth={true} placeholder="Reference No" inputProps={{ 'aria-label': 'reference no' }} onChange={e => setrefNum(e.target.value)}/>
						</Grid>


						<Grid item xs={12} sm={4} lg={4} xl={2}> 
							{/* <Input style={{marginTop:  "21px"}} fullWidth={true} placeholder="F Type" inputProps={{ 'aria-label': 'f type' }} onChange={e => setfType(e.target.value)}/> */}
							<Autocomplete
											{...selectTranTypeProps}
											id="auto-complete-1"
											autoComplete
											style={{marginBottom:"1rem"}}
											includeInputInList
											renderInput={(params) => (
												<TextField
													{...params}
													label="Type"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													//console.log(newValue.description);
													setfType(newValue.description);
												}
											}}
										/>
						</Grid>

						<Grid item xs={12} sm={4} lg={4} xl={3} style={{ display: "flex", justifyContent: "flex-end" }}> 
							<Button style={{marginTop:  "21px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						</Grid>
					</Grid>
				</div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					<MUIDataTable
						title={
							<div>
								<h3 className="header-title" style={{color:"#339933"}}>
								 Void Report
								</h3>
							</div>
						}
						data={posts}
						columns={columns}
						options={options}
					/>
				)}
			</div>
		</div>
	);
};

export default VoidReport;
